import { ReactNode, createContext, useContext, useState } from 'react';
import { Storage } from 'src/utils/storage';
import { IS_AUTHENTICATED_KEY } from 'src/contexts/AuthContext';

type LoggedInStatusContextType = {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
  logout: () => void;
  setLogoutCallback: (callback: () => void) => void;
};

const LoggedInStatusContext = createContext<LoggedInStatusContextType>(
  null as unknown as LoggedInStatusContextType
);

export const LoggedInStatusProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    Storage.getItem(IS_AUTHENTICATED_KEY) ?? false
  );
  const [logoutCallback, setLogoutCallback] = useState(() => () => {});

  const wrapInLambdaAndSetLogoutCallback = (callback: () => void) =>
    setLogoutCallback(() => callback);

  return (
    <LoggedInStatusContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        logout: logoutCallback,
        setLogoutCallback: wrapInLambdaAndSetLogoutCallback,
      }}
    >
      {children}
    </LoggedInStatusContext.Provider>
  );
};

export const useLoggedInStatus = () => {
  const context = useContext(LoggedInStatusContext);

  if (!context) {
    throw new Error(
      'useLoggedInStatus must be used within LoggedInStatusProvider'
    );
  }

  return context;
};
